.textBlock {
  width: calc(100% - 2rem);
  max-width: 576px;
  padding: 2rem 0;

  font-size: 1rem;

  p {
    margin: 1rem 0;
  }

  a {
    color: currentColor;
    text-decoration: none;
    border-bottom: 1px dotted currentColor;

    &:hover {
      border-bottom: 1px solid currentColor;
    }
  }
}